import { combineReducers } from 'redux';
import * as types from 'legacy/src/constants/types';
import { pageLoading, pageReloading } from 'legacy/src/actions/commonActions';
import { authorize, login } from 'legacy/src/components/auth/actions';

const rendering = (state = true, action) => {
  switch (action.type) {
    case login.TRIGGER:
    case authorize.TRIGGER:
    case types.LOGOUT:
    case pageLoading.TRIGGER:
      return true;
    case pageLoading.FULFILL:
    case login.SUCCESS:
    case authorize.SUCCESS:
    case types.LOGOUT_SUCCESS:
      return false;
    default:
      return state;
  }
};

const reloading = (state = false, action) => {
  switch (action.type) {
    case pageReloading.TRIGGER:
      return true;
    case pageReloading.FULFILL:
      return false;
    default:
      return state;
  }
};

const currentState = combineReducers({
  rendering,
  reloading,
});

export default currentState;
